export const routesUrl = {
  base: "/",
  baseAuth: "/auth",
  login: "/auth/login",
  baseApp: "/",
  home: "/home",
};

export const ConfigNameRoutes = {
  config: "/config",
  products: "/products",
  promotions: "/promotions",
  calendarJourney: "/calendar-journey",
  dashboardJourney: "/dashboard-journey",
  partnersJourney: "/partners-journey",
  partnersJourneyCoach: "/partners-journey/:user_id/:role",
  quotation: "/quotation",
  quotationConfig: "/quotation-config/:quotation_id?",
  nutrition: "/nutrition/:user_id/:plan_id?",
  carterization: "/carterization",
  reports: "/reports",
  configModules: "/config-modules",
  configClinicHistory: "/config-clinic-history",
  configReservations: "/config-reservations",
  configProducts: "/config-products",
  createTraining: "/create-plan-training",
  configJourneys: "/config-journey",
  createTrainingForAfiliate:
    "/create-plan-training-for-afiliate/:document_number",
  manageTraining: "/manage-training",
  createSession: "/create-session",
  updateSession: "/update-session/:sessionId",
  updateSessionRoute: "/update-session/",
  listSessions: "/manage-training/sessions",
  quotes: "/quotes",
  counter: "/counter",
  collaborators: "/collaborators",
  diaryGeneral: "/diary-general",
  groupActivityDetail: "/group-activity-detail/:activity_id",
  locations: "/locations",
  afiliates: "/afiliates",
  activitiesCalendar: "/activities-calendar",
  exercices: "manage-training/exercises",
  configTrainingPlan: "/config-training-plan",
  homeTraining: "/home",
  createMedicalProfessional: "/create-medical-professional",
  ConfigProfessional: "/config-users",
  detailAfiliate: "/detail-afiliate/:id",
  recipes: "/recipes",
  maximunCapacity: "/maximum-capacity",
  detailVirtualAfiliate:
    "/detail-virtual-afiliate/:user_id/:quote_id/:quote_type?",
  virtualAfiliates: "/virtual-afiliates",
  trainerBooking: "/trainer-booking",
  agents: "/agents",
  tickets: "/tickets",
  configTickets: "/config-tickets",
  flow: "/flow",
  coupons: "/coupons",
  chat: "/chat",
};
